import commonService from "./common.service";

const BASE = "/p2p/organizations";

const p2pOrganizationService = {
  // Organisations
  listOrganizations: () => commonService.get(BASE),
  getOrganization: (orgId) => commonService.get(`${BASE}/${orgId}`),
  createOrganization: (payload) => commonService.post(BASE, payload),
  updateOrganization: (orgId, payload) => commonService.put(`${BASE}/${orgId}`, payload),

  // Members
  listMembers: (orgId) => commonService.get(`${BASE}/${orgId}/members`),
  addMember: (orgId, payload) => commonService.post(`${BASE}/${orgId}/members`, payload),
  updateMember: (orgId, memberId, payload) =>
    commonService.put(`${BASE}/${orgId}/members/${memberId}`, payload),

  // Departments
  listDepartments: (orgId) => commonService.get(`${BASE}/${orgId}/departments`),
  createDepartment: (orgId, payload) => commonService.post(`${BASE}/${orgId}/departments`, payload),
  updateDepartment: (orgId, departmentId, payload) =>
    commonService.put(`${BASE}/${orgId}/departments/${departmentId}`, payload),

  // Designations
  listDesignations: (orgId) => commonService.get(`${BASE}/${orgId}/designations`),
  createDesignation: (orgId, payload) => commonService.post(`${BASE}/${orgId}/designations`, payload),
  updateDesignation: (orgId, designationId, payload) =>
    commonService.put(`${BASE}/${orgId}/designations/${designationId}`, payload),

  // Cost centres
  listCostCenters: (orgId) => commonService.get(`${BASE}/${orgId}/cost-centers`),
  createCostCenter: (orgId, payload) => commonService.post(`${BASE}/${orgId}/cost-centers`, payload),
  updateCostCenter: (orgId, costCenterId, payload) =>
    commonService.put(`${BASE}/${orgId}/cost-centers/${costCenterId}`, payload),

  // Roles
  listRoleCatalog: () => commonService.get(`${BASE}/role-catalog`),
};

export default p2pOrganizationService;
